import { UPDATE_REVERSAL_COUNT } from '../actions/UpdateReversalCount';

const initialState = {
  reversalCount: 0,
};

const reversalReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REVERSAL_COUNT:
      return {
        ...state,
        reversalCount: action.payload,
      };
    default:
      return state;
  }
};

export default reversalReducer;